import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { catchError, map } from 'rxjs/operators';
import Cookies from 'js-cookie';

function getSessionFromCookie() {
  return Cookies.get('sessionId') || '';
}

function getDefaultHeader() {
  const siteName = process.env.REACT_APP_BUILD_SITE !== undefined ? process.env.REACT_APP_BUILD_SITE : 'ZPAR';
  const devEmailUser =
    process.env.NODE_ENV === 'development' && getSessionFromCookie() === ''
      ? 'producto+zpar-inmobiliaria@navent.com'
      : '';

  return {
    'content-type': 'application/json;charset=UTF-8',
    sessionId: getSessionFromCookie(),
    'x-panel-portal': siteName,
    email: devEmailUser
  };
}

export function getUploadHeader() {
  const siteName = process.env.REACT_APP_BUILD_SITE !== undefined ? process.env.REACT_APP_BUILD_SITE : 'ZPAR';
  const devEmailUser =
    process.env.NODE_ENV === 'development' && getSessionFromCookie() === ''
      ? 'producto+zpar-inmobiliaria@navent.com'
      : '';
  return {
    mimeType: 'multipart/form-data',
    contentType: 'application/octet-stream boundary=something',
    sessionId: getSessionFromCookie(),
    'x-panel-portal': siteName,
    email: devEmailUser
  };
}

function setBaseUrl(path) {
  return process.env.REACT_APP_API_LEADS + path;
}

function unAuthorizedError() {
  return catchError(err => {
    return of({ error: true, ...err });
  });
}

function responseMap(r) {
  if (r.error) {
    return r;
  }
  return { error: false, data: r.response };
}

export function consumeAPI2(path, customHeaders = {}) {
  const headers = { ...getDefaultHeader(), ...customHeaders };
  const url = setBaseUrl(path);

  return ajax({
    url,
    method: 'GET',
    headers
  }).pipe(
    unAuthorizedError(),
    map(responseMap)
  );
}

export function consumeDeleteAPI2(path, customHeaders = {}) {
  const headers = { ...getDefaultHeader(), ...customHeaders };
  const url = setBaseUrl(path);

  return ajax({
    url,
    method: 'DELETE',
    headers
  }).pipe(
    unAuthorizedError(),
    map(responseMap)
  );
}

export function consumePostAPI2(path, data, customHeaders = {}) {
  const headers = { ...getDefaultHeader(), ...customHeaders };
  const url = setBaseUrl(path);
  return ajax({
    url,
    method: 'POST',
    headers,
    body: data
  }).pipe(
    unAuthorizedError(),
    map(responseMap)
  );
}

export function consumePostAPI3(path, data, customHeaders = {}) {
  const headers = { ...getUploadHeader(), ...customHeaders };
  const url = setBaseUrl(path);
  return ajax({
    url,
    method: 'POST',
    headers,
    body: data
  }).pipe(
    unAuthorizedError(),
    map(responseMap)
  );
}
